import "./style.css";
import { useHistory } from "react-router";
import { TableHeader } from "./components";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { setAlert } from "../../redux/reducers/alert";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import {
  HistoryOutlined,
  CancelPresentationOutlined,
} from "@material-ui/icons";
import { ManagementTable } from "../../components/managementTable";
import {
  deleteTransactions,
  getAllTransactions,
  searchTransactions,
} from "../../api/transactions";
import { capitalizeFirstLetter } from "../../util/Date";
import { getAllSchools } from "../../api/schools";
import recentTransactionsIcon from "../../assets/images/recent_transactions_icon.svg";

const TRANSACTION_TABS = [
  {
    status: "APPROVED",
    path: "/transactions",
    label: "text_recent_transactions",
    icon: recentTransactionsIcon,
  },
  {
    status: "PENDING",
    path: "/transactions/pending",
    label: "text_pending_transactions",
    Icon: HistoryOutlined,
  },
  {
    status: "REJECTED",
    path: "/transactions/rejected",
    label: "text_rejected_transactions",
    Icon: CancelPresentationOutlined,
  },
];

export const Transactions = ({ status = "APPROVED" }) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [SearchValue, setSearchValue] = useState("");
  const [startEntry, setStartEntry] = useState(1);
  const [endEntry, setEndEntry] = useState(10);
  //*  for get and set the items in local Storage

  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];
  //* for checking and use this selector for finding role and School
  const { token, schoolId, role, id } = useSelector((state) => state.user);

  const history = useHistory();
  const { t } = useTranslation();
  let limit = 10;
  const [payeeType, setPayeeType] = useState("STUDENT");

  const tablePayeeType = capitalizeFirstLetter(payeeType?.toLowerCase());
  const payeeTypeForManagers =
    role === "superadmin" ? "" : `(${tablePayeeType})`;
  const TRANSACTIONS_MANAGMENT_COLUMNS = [
    {
      id: "studentId",
      numeric: false,
      disablePadding: true,
      label: `${t("text_payee_id")} ${payeeTypeForManagers}`,
    },
    {
      id: "firstName",
      numeric: false,
      disablePadding: true,
      label: t("text_name"),
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: true,
      label: t("text_date"),
    },
    {
      id: "amount",
      numeric: false,
      disablePadding: true,
      label: t("text_amount"),
    },
    {
      id: "id",
      numeric: false,
      disablePadding: true,
      label: t("text_order_id"),
    },
    { id: "actions", numeric: false, disablePadding: true, label: "" },
  ];

  const dispatch = useDispatch();
  // ! Message Alert
  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };
  // ! Message Alert

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };
  //* use this function for getting all transactions from Api
  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const payload = {
        schoolId,
        role,
      };
      const response = await getAllTransactions(
        payload,
        page,
        token,
        limit,
        status
      );
      setStartEntry(page === 0 ? 1 : page * limit + 1);
      setEndEntry(
        (page + 1) * limit > response?.students.count
          ? response.students.count
          : (page + 1) * limit
      );
      if (response.status) {
        setTransactions(response?.students.rows);
        setTotalCount(response?.students.count);
      } else {
        showErrorAlert(response?.message);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      showErrorAlert(
        e || e.message || t("text_something_went_wrong_try_again_later")
      );
    }
  };

  const handlePage = (pageNumber) => setPage(pageNumber);
  useEffect(() => {
    // * use this function for seacrh the user
    if (SearchValue === "") {
      fetchTransactions();
    } else {
      (async () => {
        setLoading(true);
        try {
          setTransactions([]);
          const payload = {
            schoolId,
            role,
          };
          const response = await searchTransactions(
            payload,
            SearchValue,
            token,
            status
          );
          if (response.status) {
            setTotalCount(response?.students.count);
            setTransactions(response?.students.rows);
            if (
              response.students.count === 0 ||
              response.students.rows === []
            ) {
              showErrorAlert(t("text_records_not_found"));
            }
          }
          setLoading(false);
        } catch (e) {
          showErrorAlert(
            e.message || t("text_error_in_searching_transactions")
          );
          setLoading(false);
        }
      })();
    }
  }, [page, SearchValue, status]);

  useEffect(() => {
    setPage(0);
    setSearchValue("");
    setSelectedIds([]);
  }, [status]);
  const handleSearching = (e) => {
    setPage(0);
    setTotalCount(0);
    setSearchValue(e);
  };
  //* Use history.push for send in transactionDetails view
  const viewItem = async (id) => {
    history.push({
      pathname: `/transactions/${id}`,
      state: {
        transaction: transactions,
      },
    });
  };

  const handleSelection = (ids) => {
    setSelectedIds(ids);
  };

  const deleteCallback = async () => {
    const payload = {
      schoolId,
      role,
    };
    const response = await getAllTransactions(
      payload,
      page,
      token,
      limit,
      status
    );
    if (response.status) {
      setTransactions(response?.students.rows);
      setTotalCount(response?.students.count);
    }
    setSelectedIds([]);
  };

  const multipleDeleteCallBack = () => {
    const updatedTransactions = transactions.filter(
      (item) => selectedIds.indexOf(item.id) < 0
    );
    setTransactions(updatedTransactions);
    setSelectedIds([]);
  };
  // * For deleteTransactions
  const deleteItem = async () => {
    try {
      const response = await deleteTransactions(selectedIds, token);
      if (response && response.status) {
        multipleDeleteCallBack();
        showSuccessAlert(t("text_transaction_deleted_successfully"));
        //* Set data in localStorage to PushNotify

        local.push({
          message: "Transaction deleted successfully",
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
      } else {
        showErrorAlert(
          response.message ||
          t("text_error_in_deleting_transactions_please_try_again")
        );
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || t("text_error_in_deleting_transactions_please_try_again")
      );
    }
  };

  const fetchSchools = async () => {
    try {
      const payload = {
        role,
        id,
        schoolId,
      };
      const response = await getAllSchools(payload, token);

      if (response?.status) {
        setPayeeType(response?.schools[0].payeeType);
      }
    } catch (e) { }
  };

  useEffect(() => {
    fetchSchools();
  }, []);

  return (
    <div className="school-management-page">
      <nav className="transaction-tabs" aria-label={t("text_transactions")}>
        {TRANSACTION_TABS.map(
          ({ status: tabStatus, path, label, Icon, icon }) => (
            <button
              className={`transaction-tab ${status === tabStatus ? "transaction-tab-active" : ""
                }`}
              key={tabStatus}
              type="button"
              aria-current={status === tabStatus ? "page" : undefined}
              onClick={() => history.push(path)}
            >
              {icon ? (
                <img
                  className="transaction-tab-image"
                  src={icon}
                  alt=""
                  aria-hidden="true"
                />
              ) : (
                <Icon className="transaction-tab-icon" />
              )}
              <span>{t(label)}</span>
            </button>
          )
        )}
      </nav>

      <div className={"school-management-container"}>
        <TableHeader
          selectedIds={selectedIds}
          deleteCallback={deleteCallback}
          SearchValue={handleSearching}
          transactions={transactions}
          status={status}
        />
        {loading ? (
          <div className={"school-loader"}>
            <CircularProgress size={20} style={{ color: "black" }} />
            {t("text_fetching_transactions")}
          </div>
        ) : (
          <ManagementTable
            handleSelection={handleSelection}
            pageNumber={page}
            handlePage={handlePage}
            totalCount={totalCount}
            tableFor="transactions"
            data={transactions}
            columns={TRANSACTIONS_MANAGMENT_COLUMNS}
            viewItem={viewItem}
            deleteItem={deleteItem}
            startEntry={startEntry}
            endEntry={endEntry}
          />
        )}
      </div>
    </div>
  );
};
